<template>
  <div class="engineering">
    <van-tabs sticky animated swipe-threshold="1">
      <van-tab v-for="(item, index) in Treelist" :key="index">
        <template #title>
          <span
            @click="onClickTabs(item)"
            class="engineeringSpan"
            style="
              text-overflow: ellipsis;
              white-space: nowrap;
              overflow: hidden;
            "
            >{{ item.Name }}</span
          >
        </template>
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="getTreeInfo"
          :immediate-check="false"
        >
          <van-swipe-cell v-for="(el, inx) in list" :key="inx">
            <div
              class="myDiv"
              style="
                margin: 10px 0;
                height: auto;
                min-height: auto;
                border-radius: 0;
              "
              @click="wxClick(el)"
            >
              <div>{{ inx + 1 }} . {{ el.mobl04 }}</div>
            </div>
            <template #right>
              <van-button
                square
                type="danger"
                style="height: 100%; width: 100%"
                text="删除"
                @click="Delete(el)"
              />
            </template>
          </van-swipe-cell>
        </van-list>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { ImagePreview } from "vant";
import {
  GetModelLableSets,
  GetModelLabelSetList,
  DelModelLabelSet,
} from "@/api/index";
export default {
  name: "sceneryList",
  components: {},
  data() {
    return {
      loading: false,
      finished: false,
      pageSize: 0,
      list: [],
      Treelist: [],
      ids: "",
    };
  },
  computed: {},
  watch: {},
  methods: {
    async Delete(v) {
      let res = await DelModelLabelSet({ id: v.mobl01 });
      this.getTreeInfo();
    },
    onClickTabs(v) {
      this.ids = v.lbst03;
      this.getTreeInfo();
    },
    wxClick(item) {
      ImagePreview([this.$store.state.baseUrl + item.mobl08]);
      // let data = {
      //   imgList: [],
      //   fileList: [],
      // };
      // let type = item.mobl08.substr(item.mobl08.indexOf(".") + 1);
      // if (type == "png" || type == "jpg") {
      //   data.imgList.push(this.$store.state.baseUrl + item.mobl08);
      // } else {
      //   data.fileList.push(this.$store.state.baseUrl + item.mobl08);
      // }
      // wx.miniProgram.navigateTo({
      //   url: `/pages/download/index?data=` + JSON.stringify(data),
      // });
    },
    async getData() {
      let res = await GetModelLableSets({
        params: {
          xid: this.$store.state.pid,
        },
      });
      res.Data.unshift({
        lbst01: this.ids,
        Name: "全部",
        is: true,
        lbst03: "",
      });
      this.Treelist = res.Data;
      this.getTreeInfo();
    },
    async getTreeInfo() {
      this.loading = true;
      this.pageSize += 5;
      let res = await GetModelLabelSetList({
        params: {
          xid: this.$store.state.pid,
          uid: this.$store.state.uid,
          type: this.ids,
          pageIndex: 1,
          pageSize: this.pageSize,
          fillter: "",
        },
      });
      this.list = res.Data.list;
      if (res.Data.list.length >= res.Data.total) {
        this.finished = true;
      }
      this.loading = false;
    },
    updateData() {
      this.list = [];
      this.Treelist = [];
      this.$emit("updateLoading", "工程资料");
      this.getData();
    },
  },
  created() {},
  mounted() {
    this.getData();
  },
};
</script>
<style lang="scss" scoped>
.engineering {
  width: 100%;
  height: 100vh;
  padding: 0 40px;
  margin: 0 auto;
  /deep/ .van-tabs__line {
    background-color: rgb(255, 255, 255);
  }
  /deep/ .van-tabs__nav {
    background-color: rgba(255, 255, 255, 0);
  }
  .engineeringSpan {
    color: white;
  }
  /deep/ .van-tab__text {
    padding: 0 10px;
  }
  /deep/ .van-tab--active .van-tab__text .engineeringSpan {
    position: relative;
    z-index: 1;
    min-width: 50px;
    text-align: center;
    display: block;
    color: rgb(0, 119, 255);
    &::after {
      content: "";
      position: absolute;
      left: -5px;
      z-index: -1;
      top: 0;
      background-color: rgb(255, 255, 255);
      width: 100%;
      padding: 0 5px;
      border-radius: 10px;
      height: 100%;
    }
  }
  /deep/ .van-tabs__content {
    height: 93%;
    overflow: hidden;
    overflow-y: auto;
  }
}
.headTree {
  width: 100%;
  height: 40px;
  overflow: hidden;
  overflow-y: auto;
  background-color: red;
}
</style>
